module.exports = __webpack_public_path__ + "img/login.bb7fc99b.png";